export interface BankTransactionsAccess {
  /** Old Ember reconciliation view is listed in the navigation */
  isReconciliationViewVisible: boolean
  /** New transactions view is listed in the navigation */
  isTransactionsViewVisible: boolean
  /** CTAs pointing at "the bank view" open the new transactions view instead of the old reconciliation */
  isTransactionsDefaultView: boolean
  /** Transactions-first UX: "Banking" opens Accounts, demo banner instead of the Shine merge banner, etc. */
  isTransactionsOnboardingEnabled: boolean
}

interface GetBankTransactionsAccessOptions {
  isLegacyReconciliationViewEnabled: boolean
  isReconciliationViewAsDefaultFlagEnabled: boolean
  isUmbrellaUser: boolean
}

const reconciliationOnlyAccess: BankTransactionsAccess = {
  isReconciliationViewVisible: true,
  isTransactionsViewVisible: false,
  isTransactionsDefaultView: false,
  isTransactionsOnboardingEnabled: false,
}

export const getBankTransactionsAccess = ({
  isLegacyReconciliationViewEnabled,
  isReconciliationViewAsDefaultFlagEnabled,
  isUmbrellaUser,
}: GetBankTransactionsAccessOptions): BankTransactionsAccess => {
  if (isReconciliationViewAsDefaultFlagEnabled) {
    return reconciliationOnlyAccess
  }

  // Accountants keep the old reconciliation as their default, whatever the organization has opted into
  if (isUmbrellaUser) {
    return {
      isReconciliationViewVisible: true,
      isTransactionsViewVisible: true,
      isTransactionsDefaultView: false,
      isTransactionsOnboardingEnabled: false,
    }
  }

  if (isLegacyReconciliationViewEnabled) {
    return reconciliationOnlyAccess
  }

  return {
    isReconciliationViewVisible: false,
    isTransactionsViewVisible: true,
    isTransactionsDefaultView: true,
    isTransactionsOnboardingEnabled: true,
  }
}
